<vw-toast-popup [isOpen]="isOpen" [title]="'garden.seeds.add-sheet.title' | translate" (close)="onClose()">
  <div class="flex flex-col gap-3 px-4 pb-8">

    <!-- Scanner un sachet -->
    <button type="button" class="flex min-h-target items-center gap-3 rounded-2xl border border-vw-line p-4 text-left active:bg-vw-surface-sunk" (click)="scan()">
      <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-vw-surface-tint text-vw-primary-ink"><vw-scan-barcode-icon></vw-scan-barcode-icon></span>
      <span class="flex-1">
        <span class="block text-body font-semibold text-vw-ink">{{ 'garden.seeds.add-sheet.scan.title' | translate }}</span>
        <span class="block text-body-s text-vw-muted">{{ 'garden.seeds.add-sheet.scan.subtitle' | translate }}</span>
      </span>
      <vw-chevron-right-icon class="text-vw-muted"></vw-chevron-right-icon>
    </button>

    <!-- Chercher dans le catalogue -->
    <button type="button" class="flex min-h-target items-center gap-3 rounded-2xl border border-vw-line p-4 text-left active:bg-vw-surface-sunk" (click)="searchCatalog()">
      <span class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-vw-surface-tint p-2.5 text-vw-primary-ink"><vw-search-icon></vw-search-icon></span>
      <span class="flex-1">
        <span class="block text-body font-semibold text-vw-ink">{{ 'garden.seeds.add-sheet.catalog.title' | translate }}</span>
        <span class="block text-body-s text-vw-muted">{{ 'garden.seeds.add-sheet.catalog.subtitle' | translate }}</span>
      </span>
      <vw-chevron-right-icon class="text-vw-muted"></vw-chevron-right-icon>
    </button>
  </div>
</vw-toast-popup>
